<template>
  <div no-body class="lku-arset-unearn">
    <b-card no-body>
      <b-table
        class="mb-0"
        ref="table"
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="fields"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        :tbody-tr-class="onRowSelected"
        @row-clicked="selectItem"
        :busy="lkuLoading"
        show-empty
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
        <template #cell(selected)="data">
          <template v-if="selectedrow.includes(data.item.pinjamankey)">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
          <span class="ml-2">{{data.index+1}}</span>
        </template>
        <template v-slot:cell(last_tglpaym)="data">
          {{ data.item.last_tglpaym | moment("DD/MM/YYYY") }}
        </template>
        <template v-slot:cell(sum_pbb_amt)="data">
          {{ data.item.sum_pbb_amt | numFormat }}
        </template>
        <template v-slot:cell(sum_pbb_sttl)="data">
          {{ data.item.sum_pbb_sttl | numFormat }}
        </template>
        <template v-slot:cell(pbb_ost)="data">
          {{ data.item.pbb_ost | numFormat }}
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="3">
          <b-row class="ml-2 mt-2">
            <span class="pt-1 pr-2">Limit per page</span>
            <b-form-select
              :options="[10, 15, 20, 25]"
              :plain="true"
              v-model="tblData.limit"
              size="sm"
              style="width: 80px !important"
            />
          </b-row>
        </b-col>
        <b-col cols="5">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<style lang="scss">
.lku-arset-unearn {
  .input-group {
    padding-bottom: 2px;
    .input-group-prepend {
      label {
        padding-top: 5px;
        font-size: smaller;
        width: 90px;
      }
    }
  }
}
</style>

<script>
import toastr from "mini-toastr";

import pinjmanpayment from "../../apis/pinjamanpayment";

export default {
  data() {
    return {
      fields: [
        {
          key: "selected",
          label: "#",
          thStyle: "width:90px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "no_agreement",
          label: "No. Agreement",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "Application No.",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "CIF No.",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Nama Debitur",
          sortable: true,
        },
        {
          key: "vanumber",
          label: "VA No.",
          sortable: true,
        },
        {
          key: "last_tglpaym",
          label: "Last Paym.Date",
          thStyle: "width:90px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "matauang",
          label: "CCY",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "sum_pbb_amt",
          label: "Prepaid",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "sum_pbb_sttl",
          label: "Prepaid Allocation",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "pbb_ost",
          label: "Contract Prepaid",
          thStyle: "width:110px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
      ],
      tblData: {
        items: [],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: "no_kontrak",
        sortDesc: false,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        unearned: "1",
        no_agreement:'',no_kontrak:'',CustName:'',CustCode:'',vanumber:''
      },
      lkuLoading: false,
    };
  },
  computed: {
    // filterCustomer() {
    //   return this.tblData.customer;
    // },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    pagechange: function (newval) {
      this.tblData.page = newval;
      this.refresh();
    },
    limitchange: function (newval) {
      this.refresh();
    },
    // filterCustomer: function(newval) {
    //   this.refresh();
    // },
  },
  props: ["formdata", "selectedrow","searchdata","pinjamankeynotin"],
  created: async function () {
    if (this.formdata.items) {
      for (var key in this.formdata) {
        this.tblData[key] = this.formdata[key];
      }
    } else if(this.formdata.isrrd){
      this.tblData.isrrd = this.formdata.isrrd;
      this.refresh();
    }else {
      if (this.tblData.tgl1 || this.tblData.tgl2) {
        this.refresh();
      }
    }
    if(this.searchdata || this.pinjamankeynotin){
      this.tblData.CustCode=this.searchdata.custcode;
      this.tblData.pinjamankeynotin=this.pinjamankeynotin;
      console.log('this.pinjamankeynotin',this.pinjamankeynotin)
      this.refresh();
    }
    
    if (!this.selectedrow) {
      this.selectedrow = [];
    }
  },
  methods: {
    onRowSelected(item){
      if(!item) return;
      item._rowVariant = this.selectedrow.includes(item.pinjamankey)?'success':''
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    selectItem(item, index) {
      this.tblData.selected = item;
      this.$emit("click", this.tblData);
    },
    clearFilter(ctx) {
      this.tblData.reference = "";
      this.tblData.kodebank = "";
      this.tblData.namabank = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.customer = "";
      this.tblData.invoice = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";

      this.refresh();
    },
    refresh(ctx) {
      if(this.$refs.table){
        this.$refs.table.refresh();
      }
      
    },
    data:async function(){
      try {
        this.lkuLoading = true;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const data = await pinjmanpayment.pinjamanPrepaid(this.tblData);
        this.lkuLoading = false;
        return data;
      } catch (error) {
          this.lkuLoading = false;
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
        }
    }
  },
};
</script>
